import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {MembershipTypeSearchPageComponent} from "../membership-type-search-page/membership-type-search-page.component";

export class MembershipTypeReportSelectionData extends EntityData<MembershipTypeReportSelectionData> {
    @identifier membershipTypeId: number;
    @field name: string;
    @field description: string;
}

@Component({
    selector: "wbo-membership-type-report-selection",
    templateUrl: "./membership-type-report-selection-control.component.html"
})
export class MembershipTypeReportSelectionControlComponent {

    MembershipTypeSearchPageComponent = MembershipTypeSearchPageComponent;

    fieldName: string = "membershipType";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromMembershipType(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((member: any) => member.membershipTypeId === item.membershipTypeId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
